/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Table, Form, Badge, OverlayTrigger } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import moment from "moment";
import {
  BiDownload,
  BiDotsHorizontalRounded,
  BiShareAlt,
  BiMenuAltRight,
  BiSearch,
  BiChevronDown,
  BiSort
} from "react-icons/bi";
import { CgSortAz } from "react-icons/cg";
import SupplierService from "../../../core/service/SupplierService";
import TotalSuppliers from "../TotalSuppliers/TotalSuppliers";
import RiskPriority from "../RiskPriority/RiskPriority";
import OnboardingStatus from "../OnboardingStatus/OnboardingStatus";
import "./CompanyConnections.scss";
import Utils from "../../../core/utilities/Utils";
import Pagination from "../../../components/Pagination/Pagination";
import {
  DEFAULT_ITEMS_PER_PAGE,
  SORT_ORDER_DESC,
  LIST_DEF_SORT,
} from "../../../core/constants/common";
import ErrorHandlingService from "../../../core/service/ErrorHandlingService";

function CompanyConnections({ t }) {
  const [connections, setConnectionList] = useState([]);
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [key, setKey] = useState("");
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);

  useEffect(() => {
    getConnections(0, itemsPerPage, key, sortField);
  }, []);

  const getConnections = (pageNumber, itemsPerPageVal, key, sortField) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }
    var data = JSON.parse(localStorage.getItem("authority"));
    const company = data.profile.company.id;
    var sort = sortField + "," + order;
    SupplierService.companyConnections(company, pageNumber, perPage, key, sort)
      .then((response) => {
        var totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
        setConnectionList([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
      });
  };
  const handleSearch = (e) => {
    var searchKey = e.target.value;
    setKey(searchKey);
    getConnections(0, itemsPerPage, searchKey, sortField);
  };
  const handleSort = (val) => {
    if (sortField === val && order === "asc") {
      setOrder("desc");
    } else {
      setOrder("asc");
    }
    setSortField(val);
    getConnections(0, itemsPerPage, key, val);
  };

  return (
    <>
      <div className="SupplierList">
        <div className="List_header">
          <h5 className="MH">{t("Clients.label")}</h5>
        </div>

        <div className="List_Table_01">
          <div className="List_table-card01_head">
            <div className="List_table-card_Search_01">
              <div className="List_table-card_Search_Box">
                <Form>
                  <input
                    type="text"
                    className="form-control"
                    value={key}
                    onChange={handleSearch}
                  />
                  <Link to="#" className="Search_iocnBox">
                    <BiSearch />
                  </Link>
                </Form>
              </div>
            </div>
            <div className="List_table-card01_sort">
              <ul>
                <li className='filter'>
                  <button className="btn btn-secondary"><CgSortAz /> {t("Filter.label")}</button>
                </li>
              </ul>
            </div>
          </div>
          <div className="card List_table-card01">
            <Table responsive="sm">
              <thead>
                <tr>
                  <th className="th_check">
                    <Form.Check
                      inline
                      name="group1"
                      type="checkbox"
                      id="inline-checkbox-1"
                    />
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("legalName")}>
                      {t("ClientName.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("email")}>
                      {t("Email.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>{t("ContactNumber.label")}</th>
                  <th>
                    <Link to="#" onClick={() => handleSort("createdDate")}>
                      {t("CreatedDate.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("invitationStatus")}>
                      {t("Onboarding.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>{t("Risk.label")}</th>
                  {/* <th></th> */}
                </tr>
              </thead>
              <tbody>
                {connections?.map((item) => (
                  <tr key={item.invitationId}>
                    <td className="checkbox">
                      {" "}
                      <Form.Check
                        inline
                        name="group1"
                        type="checkbox"
                        id="inline-checkbox-1"
                      />
                    </td>
                    <td>
                      {/* <OverlayTrigger
                                placement="top"
                                overlay={Utils.renderTooltip(
                                  t("Clicktoviewcompanydetails.label")
                                )}
                              >
                      <Link to="#">{item.legalName}</Link>
                      </OverlayTrigger> */}
                      {item.legalName}
                      <p className="m-0">{item.countryName}</p>
                    </td>
                    <td>{item.email}</td>
                    <td>
                      +{item.phoneNumber.code.phoneCode}{" "}
                      {item.phoneNumber.number}
                    </td>
                    <td>{moment(item.createdDate).format("MMM DD, YYYY")}</td>
                    <td>
                      {(() => {
                        switch (item.invitationStatus) {
                          case "ONBOARDED":
                            return (
                              <Badge bg="badge-Onboarded">
                                {item.invitationStatus}
                              </Badge>
                            );
                          case "INVITED":
                            return (
                              <Badge bg="badge-Invited">
                                {item.invitationStatus}
                              </Badge>
                            );
                          case "ACCEPTED":
                            return (
                              <Badge bg="badge-Accepted">
                                {item.invitationStatus}
                              </Badge>
                            );
                          case "COMPLETED":
                            return (
                              <Badge bg="badge-Completed">
                                {item.invitationStatus}
                              </Badge>
                            );
                          case "DRAFT":
                            return (
                              <Badge bg="badge-Draft">
                                {item.invitationStatus}
                              </Badge>
                            );
                          default:
                            return " ";
                        }
                      })()}
                    </td>
                    <td>
                      <Badge bg="badge-Low">Low</Badge>
                    </td>
                    {/* <td>
                      <Button variant="blank_outline">
                        <BiDotsHorizontalRounded />
                      </Button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="p-2 List_footer_count">


              <Pagination
                itemsTotalCount={itemsTotalCount}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                alwaysShown={true}
                setItemsPerPage={setItemsPerPage}
                pageClicked={(pageNum, perPage) => {
                  getConnections(pageNum, perPage, key, sortField);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(CompanyConnections);
